export default __webpack_public_path__ + "static/media/SarahDuda.e7abd981.png";